// extracted by mini-css-extract-plugin
module.exports = {"custom":"c25f4158d348327e2136ab1d3599e5a1-less"};